export const BonusWalletTypes = Object.freeze({
    bonusEarnings: 0,
    referralBonusEarnings: 1
})